export const SCREENSHOT_PATH = "https://intandemly-media.sfo2.digitaloceanspaces.com/HR/";